import Dexie, { Table } from "dexie";
import { ITicketData, IVerifyTicketResponse, IWhiteList } from './ApiClient';

export enum ValidationStatus {
    NotValid = 0,
    Valid = 1
}

export enum TicketVerifyMode {
    Online = 0,
    Offline = 1
}

export interface IScanData {
    timestamp?: Date;
    eventId: string;
    gate: string;
    code: string;
    status: ValidationStatus;
    verify?: IVerifyTicketResponse;
    ticket?: ITicketData;
    syncTime?: Date | null;
    syncSucceeded?: boolean;
    verifyMode: TicketVerifyMode; 
}

export interface ITicketStoreData {
    eventId?: string;
    lastUpdateTime?: Date;
    tickets?: IWhiteList[];
}

export interface ICacheData {
    key: string;
    value: any;
}

export class GateKeeperDb extends Dexie {

    constructor() {
        super('GateKeeper');
        this.version(5).stores({
            scanHistory: 'timestamp, eventId, code, status, syncTime',
            ticketList: 'eventId',
            cache: 'key'
        });
    }

    scanHistory!: Table<IScanData, Date>;

    ticketList!: Table<ITicketStoreData, string>;

    cache!: Table<ICacheData, string>;
}

export const db = new GateKeeperDb();